import React, { Component } from "react";
import { connect } from "react-redux";

import Element from "./Element";
import Legend from "./Legend";

import "../styles/table.scss";
import Logo from "../assets/atomicLimits.jpg";
import cc from "../assets/cc.png";
import { getProcesses } from "../actions/processActions";
import {
  enterPassword,
  getSubmissions,
  getComments
} from "../actions/adminActions";

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = { adminClicks: 0 };
  }

  componentDidMount() {
    this.props.getProcesses();
  }

  render() {
    const groupLabelY = [1, 2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 2, 2, 2, 2, 1];

    return (
      <div className="table">
        <div
          key={"lanthanoids"}
          style={{
            gridColumn: 4,
            gridRow: 7
          }}
        >
          <Element atomicNumber="57 - 71" symbol="La-Lu" special />
        </div>
        {this.props.elements
          .filter(element => element.number < 84)
          .map(element => {
            return (
              <div
                key={element.number}
                style={{
                  gridColumn: element.xpos + 1,
                  gridRow: element.ypos + 1
                }}
              >
                <Element
                  selected={this.props.selectedElement === element.symbol}
                  atomicNumber={element.number}
                  symbol={element.symbol}
                  pure={element.pure}
                  tellurium={element.tellurium}
                  other={element.other}
                  fluorine={element.fluorine}
                  nitrogen={element.nitrogen}
                  oxygen={element.oxygen}
                  sulfur={element.sulfur}
                  selenium={element.selenium}
                />
              </div>
            );
          })}
        {Array.from({ length: 18 }, (x, i) => i + 1).map(group => (
          <div
            key={group}
            style={{
              gridColumn: group + 1,
              gridRow: groupLabelY[group - 1]
            }}
            className="table--label"
          >
            <div className="center-horizontal bottom">{group}</div>
          </div>
        ))}
        <div className="table--label table--label--lanthanoids">
          <div className="center">Lanthanoids</div>
        </div>
        <div className="table--label table--label--copyright">
          <div className="center fullWidth">
            www.AtomicLimits.com - DOI:{" "}
            <a href="https://doi.org/10.6100/alddatabase">
              10.6100/alddatabase
            </a>
          </div>
        </div>
        <div className="table--label table--label--reference">
          <div className="center fullWidth">
            <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">
              <img
                alt="Creative Commons License"
                style={{ borderWidth: 0 }}
                src={cc}
              />
            </a>
            <br />
            This work is licensed under a{" "}
            <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">
              Creative Commons Attribution 4.0 International License
            </a>
            .
          </div>
        </div>
        <div style={{ gridColumn: 19, gridRow: 10 }}>
          <div className="table--logo">
            <img
              className="center"
              width="98%"
              src={Logo}
              alt="Atomic limits logo"
              onClick={() => {
                if (!this.props.password) {
                  if (this.state.adminClicks < 4) {
                    this.setState({ adminClicks: this.state.adminClicks + 1 });
                    return;
                  }

                  const password = window.prompt("Enter admin password", "");
                  if (password) {
                    this.props.enterPassword(password);
                    this.props.getSubmissions(password);
                    this.props.getComments(password);
                  }
                } else {
                  this.props.getSubmissions(this.props.password);
                  this.props.getComments(this.props.password);
                }
              }}
            />
          </div>
        </div>
        <Legend filterYear={this.props.filterYear} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.process.loading,
    elements: state.process.elements,
    password: state.admin.password,
    selectedElement: state.selected.element,
    filterYear: state.process.filterYear
  };
}

export default connect(
  mapStateToProps,
  {
    getProcesses,
    enterPassword,
    getSubmissions,
    getComments
  }
)(Table);
